var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mymap"},[_c('img',{staticStyle:{"max-width":"800px"},attrs:{"src":("./images/mymap/" + _vm.mapName + ".png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }